import { render } from "./EditMeetingTemplatePoints.vue?vue&type=template&id=620fb0f8&scoped=true"
import script from "./EditMeetingTemplatePoints.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./EditMeetingTemplatePoints.vue?vue&type=script&charset=utf-8&lang=js"

import "./EditMeetingTemplatePoints.vue?vue&type=style&index=0&id=620fb0f8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-620fb0f8"]])

export default __exports__